import classNames from 'classnames';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import React from 'react';
import requireIf from 'react-required-if';

const propTypes = exact({
  blockName: PropTypes.string,
  buttonType: PropTypes.string,
  elementType: PropTypes.oneOf(['button', 'link']),
  handleClick: requireIf(PropTypes.func, (props) => props.elementType === 'button'),
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  modifier: PropTypes.string,
  text: PropTypes.string.isRequired,
  url: requireIf(PropTypes.string, (props) => props.elementType === 'link'),
});

const defaultProps = {
  blockName: null,
  buttonType: 'button',
  elementType: 'button',
  isDisabled: false,
  isLoading: false,
  modifier: 'ghost',
};

function Button(props) {
  const buttonClasses = classNames(props.blockName, 'Button', `Button-${props.modifier}`, {
    disabled: props.isDisabled,
    loading: props.isLoading,
  });

  if (props.elementType === 'button') {
    return (
      <button type={props.buttonType} onClick={props.handleClick} className={buttonClasses}>
        <span className="Button_text">{props.text}</span>
      </button>
    );
  }

  if (props.elementType === 'link') {
    return (
      <a href={props.url} className={buttonClasses}>
        <span className="Button_text">{props.text}</span>
      </a>
    );
  }
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
